import styled from 'styled-components'

export const BackButton = styled.a`
    margin: 24px;
`

export const AvatarWrapper = styled.div`
    margin: 3em auto 5em 0;
    padding: 0 2em;
    max-width: 64em;
    display: flex;
    justify-content: left;
`

export const Avatar = styled.div`
    margin-right: 1em;
    position: relative;
`

export const AvatarContainer = styled.div`
  margin-right: 1em;
`

export const AvatarImage = styled.img<{ width: number }>`
  border-radius: 75px;
  width: ${({ width }) => (width < 600 ? '50px' : '140px')};
  height: ${({ width }) => (width < 600 ? '50px' : '140px')};
`

export const NameContainer = styled.div`
  display: flex;
  justify-content: column;
`